<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.stations_filter()">
            <div class="four fields">
                <div class="field">
                    <label>{{ $t('models.attributes.stations.name') }}</label>
                    <input type="text"
                        v-model="filter.columns.name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.code') }}</label>
                    <input type="text"
                        v-model="filter.columns.code"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.phone') }}</label>
                    <input type="text"
                        v-model="filter.columns.phone"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.note') }}</label>
                    <input type="text"
                        v-model="filter.columns.note"
                    >
                </div>
            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.stations_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>

export default {
    name: "OperationsFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.stations_module
        },
        filter() {
            return this.current_store.filter
        },
        customers() {
            return [{
                company_name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.customers)
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
<style scoped lang="scss">

</style>
